import React, { useState } from "react";
import "./Gallery.css";

const images = [
  "/images/staff.webp",
   "/images/academians.webp",,
     "/images/Assembly.webp",
      "/images/Boys-act.webp",
       "/images/boys-branch.webp",
        "/images/boyss.webp",
         "/images/children.webp",
           "/images/computer-Lab.webp",
            "/images/girls-branch.webp",
             "/images/girlz-branch.webp",
                "/images/ground.webp",
                "/images/kids (1).webp",
                 "/images/kids.webp",
                  "/images/kidss.webp",
                   "/images/Labs.webp",
                    "/images/rangilpur-branch.webp",
      "/images/banner.webp",
        "/images/Board.webp",
          "/images/boardyear2.webp",




];

function Gallery() {
  const [selectedImg, setSelectedImg] = useState(null);

  return (
    <div className="gallery-container">
      <h1 className="gallery-title">School Gallery</h1>
      <div className="gallery-grid">
        {images.map((src, index) => (
          <div
            key={index}
            className="gallery-item"
            onClick={() => setSelectedImg(src)}
          >
            <img src={src} alt={`gallery-${index}`} />
          </div>
        ))}
      </div>

      {/* Lightbox */}
      {selectedImg && (
        <div className="lightbox" onClick={() => setSelectedImg(null)}>
          <span className="close">&times;</span>
          <img src={selectedImg} alt="enlarged" className="lightbox-img" />
        </div>
      )}
    </div>
  );
}

export default Gallery;
